import React, { FC, ReactNode, useEffect, useRef } from 'react';

import classNames from 'classnames';

import { useClickOutside } from '../../hooks/useClickOutside';
import { CloseButton } from '../../shared/ui';

export interface IModalContainerProps {
  title?: string;
  onClose?: () => void;
  children: ReactNode;
  width?: string; // e.g., 'w-1/2', 'w-3/4', 'max-w-xl'
  height?: string; // e.g., 'h-1/2', 'h-3/4', 'max-h-[80vh]'
  rounded?: string;
  clickOutsideMode?: boolean;
}
export const ModalContainer: FC<IModalContainerProps> = ({
  title,
  onClose,
  children,
  width,
  height,
  rounded,
  clickOutsideMode,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const modalContentClasses = classNames(
    'flex flex-col think-scroll bg-white  overflow-x-auto overflow-y-auto justify-between',
    // Mobile styles: full screen and no rounded corners
    'rounded-none',
    // Non-mobile styles: apply rounded corners only on large screens and up
    rounded ? rounded : 'lg:rounded-card', // <--- ADDED THIS LINE!
    width ? width : 'w-auto',
    height ? height : 'h-auto',

    'p-[20px]',
  );

  useClickOutside(ref, () => {
    clickOutsideMode && onClose?.();
  });

  //disable scorll
  useEffect(() => {
    document.body.classList.add('overflow-hidden');

    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, []);

  return (
    <div className="w-full h-full fixed bottom-0 top-0 right-0 left-0 z-modal bg-ink-muted/40 flex xs:items-center justify-center md:p-[15px] overflow-hidden">
      <div className={modalContentClasses} ref={ref}>
        {(onClose || title) && (
          <div className={classNames('flex flex-row-reverse text-display-s place-content-between mb-4', {})}>
            {onClose && <CloseButton onClick={() => onClose()} />}
            {title && <p>{title}</p>}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
